import { Box, Flex, Text } from '@chakra-ui/react'
import { generatePath } from 'react-router'
import { LinkTable } from 'src/components/LinkTable/LinkTable'
import { MemberLabel } from 'src/components/MemberLabel/MemberLabel'
import { Paths } from 'src/constants/paths'
import { useSelectedTrial } from 'src/features/auth/context'
import { CriteriaListScreenDocument } from 'src/lib/gql-client'
import { useGqlQuerySWR } from 'src/lib/gql-client/request'
import { formatDate } from 'src/utils/formatDate'
import { getFullName } from 'src/utils/getFullName'

import { AddCriteriaButton } from '../AddCriteriaButton/AddCriteriaButton'
import { CriteriaStatusBadge } from '../CriteriaStatusBadge/CriteriaStatusBadge'

export const CriteriaListScreen: React.FC = () => {
  const {
    data: { criteriaList },
  } = useGqlQuerySWR(CriteriaListScreenDocument, {})

  const { selectedTrial } = useSelectedTrial()

  return (
    <Flex as="main" h="full" p="6" direction="column">
      <Flex gap={4} align="center">
        <Text as="h1" fontSize="xl" fontWeight="bold">
          選択除外基準一覧
        </Text>
        <AddCriteriaButton />
      </Flex>
      <Box mt="6" flex="1" overflow="auto">
        <LinkTable
          data={criteriaList.criteriaList}
          columns={[
            {
              key: 'status',
              renderHeader: 'ステータス',
            },
            {
              key: 'title',
              renderHeader: 'タイトル',
            },
            {
              key: 'actionTrialMember',
              renderHeader: '最終操作者',
            },
            {
              key: 'lastSavedAt',
              renderHeader: '最終更新日',
            },
            {
              key: 'publishedAt',
              renderHeader: '公開日',
            },
          ]}
          linkTarget="title"
          link={criteria =>
            generatePath(Paths.CriteriaDetail, {
              trialUid: selectedTrial.uid,
              criteriaUid: criteria.criteriaUid,
            })
          }
          renderRow={criteria => ({
            rowId: criteria.criteriaUid,
            columnValues: {
              status: {
                renderColumn: (
                  <CriteriaStatusBadge status={criteria.latestLog.status} />
                ),
              },
              title: {
                renderColumn: criteria.latestDetail.title,
              },
              actionTrialMember: {
                renderColumn: (
                  <MemberLabel
                    role={criteria.latestLog.actionTrialMember.role}
                    displayName={getFullName(
                      criteria.latestLog.actionTrialMember.user,
                    )}
                  />
                ),
                tdProps: { maxW: '240px' },
              },
              lastSavedAt: {
                renderColumn: formatDate(
                  criteria.latestLog.savedAt,
                  'YYYY/MM/DD (ddd) HH:mm',
                ),
                tdProps: { minW: '160px' },
              },
              publishedAt: {
                renderColumn: !!criteria.publishedAt
                  ? formatDate(criteria.publishedAt, 'YYYY/MM/DD (ddd) HH:mm')
                  : '',
                tdProps: { minW: '160px' },
              },
            },
          })}
        />
      </Box>
    </Flex>
  )
}
